export default __webpack_public_path__ + "static/media/manual04.d06ef16e.png";